// @ts-nocheck

import { OutputSelector, Selector } from 'reselect'

import { createDeepEqualSelector } from 'Redux/selectors/index'
import {
  EventDetails,
  InfluencerCampaign,
  InfluencerState,
  InfluencerCampaignsInProgress,
  InfluencerCampaignsAwaitingreview,
  InfluencerCampaignsCompleted,
  InfluencerCampaignsCanceled,
} from 'Redux/reducers/influencerReducer'

type TState = {
  influencer: InfluencerState
}

const getState: Selector<TState, InfluencerState> = state => state.influencer

export const getConfirmationToken: OutputSelector<
  unknown,
  string,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ token }) => token)

export const getInfluencerCampaigns: OutputSelector<
  unknown,
  InfluencerCampaign[],
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ campaigns }) => campaigns)

export const getInfluencerEventStatistics: OutputSelector<
  unknown,
  {
    newTracks: number
    inProgress: number
    awaitingReview: number
    completed: number
    canceled: number
  },
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ eventStatistics }) => eventStatistics)

export const getOpenedCampaign: OutputSelector<
  unknown,
  InfluencerCampaign,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ campaigns, openedCampaignId }) =>
  campaigns.find(({ id }) => openedCampaignId === id)
)

export const getTiktokCampaignEvents = createDeepEqualSelector(
  getState,
  ({ events }) => events
)

export const getCampainVideos = createDeepEqualSelector(
  getState,
  ({ videos }) => videos
)

export const getInfluencerCampaignsInProgress: OutputSelector<
  unknown,
  InfluencerCampaignsInProgress[],
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ campaignsInProgress }) => campaignsInProgress
)

export const getInfluencerCampaignsAwaitingReview: OutputSelector<
  unknown,
  InfluencerCampaignsAwaitingreview[],
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ campaignsAwaitingReview }) => campaignsAwaitingReview
)

export const getInfluencerCampaignsCompleted: OutputSelector<
  unknown,
  InfluencerCampaignsCompleted[],
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ campaignsCompleted }) => campaignsCompleted
)

export const getInfluencerCampaignsCanceled: OutputSelector<
  unknown,
  InfluencerCampaignsCanceled[],
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ campaignsCanceled }) => campaignsCanceled
)
export const getEventDetails: OutputSelector<
  unknown,
  EventDetails,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ eventDetails }) => eventDetails)

export const getEventId: OutputSelector<
  unknown,
  number,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ eventDetailsId }) => eventDetailsId)
